<ion-modal
    [class.pt-0]="env.STATUS_BAR"
    (willPresent)="isModalOpen(true)"
    (willDismiss)="isModalOpen(false)"
    (didPresent)="onDidPresent()"
    trigger="{{ modalType }}">
    <ng-template>
        <section class="flex-column flex h-full text-base" ridangoAppTrapFocus>
            <div
                class="gl-light:bg-primary relative flex items-center bg-white px-2 dark:bg-contrast-black"
                [ngClass]="{ 'safe-top': env.STATUS_BAR, 'py-3': !env.STATUS_BAR, 'pb-3': env.STATUS_BAR }">
                <div class="w-12"></div>
                <h2 class="flex-1 text-center text-base font-semibold">
                    {{
                        (modalType === modalTypeEnum.Origin
                            ? 'JOURNEY_SEARCH_HEADER_ORIGIN'
                            : 'JOURNEY_SEARCH_HEADER_DESTINATION'
                        ) | translate
                    }}
                </h2>
                <ion-button
                    class="flex w-12 items-center justify-center text-xs font-semibold normal-case !leading-none text-secondary dark:text-contrast-yellow"
                    [attr.aria-label]="'LOCAL_BTN_CLEAR' | translate"
                    (click)="closeModal()"
                    fill="clear">
                    <ion-icon
                        class="vl-app-light:text-grey-zambezy var-app-light:text-grey-zambezy orb-app-light:text-grey-zambezy text-lg dark:filter-yellow"
                        title="{{ 'LOCAL_BTN_CLEAR' | translate }}"
                        aria-label="{{ 'LOCAL_BTN_CLEAR' | translate }}"
                        src="{{ assetsPath$ | async }}/img/journey-planner/icon-cross.svg"></ion-icon>
                </ion-button>
            </div>

            <div
                class="shadow-md"
                [ngClass]="{
                    'bg-[var(--color-primary)] dark:bg-contrast-black': this.env.THEME_NAME === themeFeature.GOTLAND_V2,
                    'bg-white': this.env.THEME_NAME !== themeFeature.GOTLAND_V2
                }">
                <div class="px-4">
                    <ion-item class="relative" color="light" lines="none" detail="false">
                        <ion-icon
                            class="vl-app-light:text-grey-zambezy var-app-light:text-grey-zambezy text-old_silver text-[2rem] dark:text-contrast-black"
                            src="{{ assetsPath$ | async }}/img/journey-planner/origin.svg"
                            aria-hidden="true"></ion-icon>
                        <ion-label>
                            <span
                                class="var-app-light:text-grey-zambezy text-base text-ironside_grey dark:text-contrast-black"
                                aria-hidden="true">
                                {{
                                    (modalType === modalTypeEnum.Origin ? 'LOCAL_LABEL_FROM' : 'LOCAL_LABEL_TO')
                                        | translate
                                }}:&nbsp;
                            </span>
                        </ion-label>
                        <ion-input
                            class="text-base"
                            #input
                            [value]="searchValue"
                            (ionChange)="onSearchChange($event.target.value)"
                            clearInput></ion-input>
                    </ion-item>

                    <div class="location-buttons flex">
                        <ion-button
                            class="var-app-light:text-primary mx-0 my-2 flex-1 font-semibold normal-case text-secondary dark:text-contrast-yellow"
                            [attr.aria-label]="'JOURNEY_SEARCH_CURRENT_LOCATION' | translate"
                            [disabled]="(location$ | async)?.coordinates === null"
                            (click)="setCurrentLocation()"
                            expand="full"
                            shape="round"
                            fill="clear">
                            <div class="flex flex-col items-center gap-2 whitespace-normal text-base">
                                <ion-icon
                                    class="text-[2rem]"
                                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-location.svg">
                                </ion-icon>
                                {{ 'JOURNEY_SEARCH_CURRENT_LOCATION' | translate }}
                            </div>
                        </ion-button>

                        <ion-button
                            class="var-app-light:text-primary mx-0 my-2 flex-1 font-semibold normal-case text-secondary dark:text-contrast-yellow"
                            [attr.aria-label]="'JOURNEY_SEARCH_SELECT_FROM_MAP' | translate"
                            (click)="isMobileDevice() ? openModal() : closeModal()"
                            expand="full"
                            shape="round"
                            fill="clear">
                            <div class="flex flex-col items-center gap-2 whitespace-normal text-base">
                                <ion-icon
                                    class="text-[2rem]"
                                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-map.svg"></ion-icon>
                                {{ 'JOURNEY_SEARCH_SELECT_FROM_MAP' | translate }}
                            </div>
                        </ion-button>
                    </div>

                    <div
                        class="flex w-full overflow-y-auto border-t border-solid"
                        *ngIf="
                            this.env.JOURNEY_PLANNER?.SHOW_FAVORITES_STOPS_AND_LOCATIONS &&
                            (favoriteStops?.length || (favoriteLocations$ | async)?.length)
                        ">
                        <button
                            class="favorite-item flex-column flex-align-center flex justify-center px-2 pb-4 pt-6 dark:text-contrast-yellow"
                            *ngFor="let stop of favoriteStops"
                            (click)="setFavoriteStop(stop)">
                            <ion-icon
                                class="var-app-light:text-secondary text-[2rem] text-primary dark:filter-yellow"
                                [src]="(assetsPath$ | async) + '/img/journey-planner/favorite.svg'"></ion-icon>
                            <p class="var-app-light:text-black">{{ stop.name }}</p>
                            <p
                                class="inline !max-w-[110px] truncate text-xs font-medium leading-4 text-grey-zambezy dark:text-contrast-yellow"
                                *ngIf="this.env.JOURNEY_PLANNER?.SHOW_MUNICIPALITY_IN_STOP_NAME && stop.desc">
                                {{ stop.desc }}
                            </p>
                        </button>
                        <button
                            class="favorite-item flex-column flex-align-center g-8 flex justify-center px-2 pb-4 pt-6 dark:text-contrast-yellow"
                            *ngFor="let location of favoriteLocations$ | async"
                            (click)="setFavoriteLocation(location)">
                            <ion-icon
                                class="var-app-light:text-secondary text-3xl text-primary dark:filter-yellow"
                                [src]="(assetsPath$ | async) + '/img/journey-planner/favorite.svg'"></ion-icon>
                            <p>{{ location.name }}</p>
                        </button>
                    </div>

                    <div class="pb-2" *ngIf="(location$ | async)?.coordinates === null">
                        <ridango-ui-alert type="info" iconColor="black">
                            <div
                                class="gl-light:text-white vl-app-light:text-white var-app-light:text-white text-black dark:text-contrast-yellow">
                                {{ 'JOURNEY_SEARCH_TURN_ON_LOCATION' | translate }}
                            </div>
                        </ridango-ui-alert>
                    </div>
                </div>
            </div>
            <div class="sr-only" *ngIf="searchService.searchResultsAnnouncement$ | async" aria-live="assertive">
                {{ searchService.searchResultsAnnouncement$ | async }}
            </div>
            <div
                class="mt-4 bg-white px-4 shadow-md"
                *ngIf="recentSearchItems?.length > 0 && (currentSearchPhrase === '' || currentSearchPhrase === null)">
                <rwidget-search-recents
                    [recents]="recentSearchItems"
                    (select)="handleSearchItemSelect($event)"
                    (clear)="clearRecentSearchItems()">
                </rwidget-search-recents>
            </div>
            <div
                class="android-bottom-safe-area overflow-y-auto"
                *ngIf="
                    currentSearchPhrase?.length > 0 &&
                    (searchResultItems?.stopRoutes.length ||
                        searchResultItems?.addresses.length ||
                        searchResultItems?.poi.length)
                ">
                <div class="h-4 bg-[#F5F5F5] shadow-t-md-inset dark:bg-contrast-black"></div>
                <div class="bg-white px-4">
                    <ng-container
                        *ngTemplateOutlet="
                            searchResultTemplate;
                            context: {
                                items: searchResultItems.stopRoutes,
                                hasPreviousResults: false,
                                resultType: TransitNetworkPartType.Stop
                            }
                        ">
                    </ng-container>

                    <ng-container
                        *ngTemplateOutlet="
                            searchResultTemplate;
                            context: {
                                items: searchResultItems.addresses,
                                hasPreviousResults: searchResultItems.stopRoutes.length > 0,
                                resultType: TransitNetworkPartType.Location
                            }
                        ">
                    </ng-container>

                    <ng-container
                        *ngTemplateOutlet="
                            searchResultTemplate;
                            context: {
                                items: searchResultItems.poi,
                                hasPreviousResults:
                                    searchResultItems.stopRoutes.length > 0 || searchResultItems.addresses.length > 0,
                                resultType: TransitNetworkPartType.POI
                            }
                        ">
                    </ng-container>
                </div>
            </div>
            <div
                class="m-4 text-center"
                *ngIf="
                    currentSearchPhrase &&
                    !searchResultItems?.stopRoutes.length &&
                    !searchResultItems?.addresses.length &&
                    !searchResultItems?.poi.length &&
                    !this.searchLoading
                ">
                <div class="vl-app-light:text-old_silver-lighter my-4 text-grey-dark dark:text-contrast-yellow">
                    <svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M26.2578 29.8187L39.0821 42.643L41.9105 39.8145L29.0862 26.9902L26.2578 29.8187Z"
                            fill="currentColor" />
                        <path
                            d="M17.5111 35.8621C7.82785 35.8621 0 27.8223 0 17.931C0 8.03978 7.82785 0 17.5111 0C27.1943 0 35.0222 8.03978 35.0222 17.931C35.0222 27.8223 27.1943 35.8621 17.5111 35.8621ZM17.5111 31.8621C24.9609 31.8621 31.0222 25.6367 31.0222 17.931C31.0222 10.2254 24.9609 4 17.5111 4C10.0613 4 4 10.2254 4 17.931C4 25.6367 10.0613 31.8621 17.5111 31.8621Z"
                            fill="currentColor" />
                    </svg>
                </div>

                <p>{{ 'SEARCH_RESULTS_NOT_FOUND' | translate }}</p>
            </div>

            <ridango-ui-basic-loading-spinner *ngIf="this.searchLoading"></ridango-ui-basic-loading-spinner>
        </section>
    </ng-template>

    <ng-template #loadMoreBtnTemplate let-resultType="resultType">
        <ng-container *ngIf="loadMoreBtnVisible(resultType)">
            <div class="border-ironside_grey-100 border-t border-solid dark:border-contrast-yellow"></div>
            <div class="px-10 pb-2">
                <button
                    class="py-4 font-semibold leading-5 text-primary dark:text-contrast-yellow"
                    (click)="loadMoreItems(resultType)"
                    attr.aria-label="{{ 'SHOW_MORE_LOCATIONS' | translate }}"
                    tabindex="0">
                    {{ 'SHOW_MORE_LOCATIONS' | translate }}
                </button>
            </div>
        </ng-container>
    </ng-template>

    <ng-template
        #searchResultTemplate
        let-items="items"
        let-hasPreviousResults="hasPreviousResults"
        let-resultType="resultType">
        <ng-container *ngFor="let searchItem of items; let i = index">
            <div
                class="border-ironside_grey-100 border-t border-solid dark:border-contrast-yellow"
                *ngIf="shouldShowDivider(i, hasPreviousResults)"></div>
            <rwidget-search-item
                [searchItem]="searchItem"
                [searchText]="searchText"
                (select)="handleSearchItemSelect($event)">
            </rwidget-search-item>
        </ng-container>

        <ng-container
            *ngTemplateOutlet="
                loadMoreBtnTemplate;
                context: {
                    resultType: resultType
                }
            ">
        </ng-container>
    </ng-template>
</ion-modal>
